import { render } from "./modalAsignarLotes.vue?vue&type=template&id=bc6d736c&scoped=true"
import script from "./modalAsignarLotes.vue?vue&type=script&lang=js"
export * from "./modalAsignarLotes.vue?vue&type=script&lang=js"

import "./modalAsignarLotes.vue?vue&type=style&index=0&id=bc6d736c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6d736c"]])

export default __exports__